import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SecurePipe } from '../../pipes/secure.pipe';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss'],
  imports: [CommonModule, SecurePipe, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ImageModalComponent {
  private readonly data = inject(MAT_DIALOG_DATA) as { imageUrls: string[], currentIndex?: number };
  private readonly dialogRef = inject(MatDialogRef<ImageModalComponent>);

  ngOnInit(): void {
    this.imageUrls = this.data.imageUrls ?? [];
    this.currentIndex = this.data.currentIndex ?? 0;
  }

  imageUrls: string[] = [];
  
  currentIndex: number = 0;
  isLoading: boolean = true;
  imageLoaded: boolean = false;

  get isFirstImage(): boolean {
    return this.currentIndex == 0;
  }

  get isLastImage(): boolean {
    return this.currentIndex == this.imageUrls.length - 1;
  }

  previousImage(): void {
    if (!this.isFirstImage) {
      this.isLoading = true;
      this.imageLoaded = false;
      this.currentIndex--;
    }
  }

  nextImage(): void {
    if (!this.isLastImage) {
      this.isLoading = true;
      this.imageLoaded = false;
      this.currentIndex++;
    }
  }

  onImageLoad(): void {
    this.isLoading = false;
    this.imageLoaded = true;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}